'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _styling = require('@rexlabs/styling');

var _redux = require('../utils/redux');

var _toastPortal = require('./toast-portal');

var _toastPortal2 = _interopRequireDefault(_toastPortal);

var _connectedToast = require('./connected-toast');

var _connectedToast2 = _interopRequireDefault(_connectedToast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyles = (0, _styling.StyleSheet)({
  container: {
    flexDirection: 'column'
  }
});

// Memoizing here because we filter the toasts by target name!
var memMapStateToProps = {};
var mapStateToProps = function mapStateToProps(state, props) {
  return { toasts: state.toasts };
};

var ToastProvider = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec2 = (0, _styling.styled)(defaultStyles), _dec(_class = _dec2(_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ToastProvider, _PureComponent);

  function ToastProvider() {
    (0, _classCallCheck3.default)(this, ToastProvider);
    return (0, _possibleConstructorReturn3.default)(this, (ToastProvider.__proto__ || (0, _getPrototypeOf2.default)(ToastProvider)).apply(this, arguments));
  }

  (0, _createClass3.default)(ToastProvider, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          Toast = _props.Toast,
          duration = _props.duration,
          isClosable = _props.isClosable,
          toasts = _props.toasts,
          children = _props.children,
          s = _props.styles;


      var targets = [];
      toasts.forEach(function (t) {
        if (!targets.includes(t.target)) {
          targets.push(t.target);
        }
      });

      return _react2.default.createElement(
        'div',
        null,
        children,
        targets.map(function (target) {
          return _react2.default.createElement(
            _toastPortal2.default,
            { key: target, target: target },
            toasts.map(function (toast) {
              return _react2.default.createElement(Toast, (0, _extends3.default)({
                key: toast.id,
                duration: duration,
                isClosable: isClosable
              }, toast));
            })
          );
        })
      );
    }
  }]);
  return ToastProvider;
}(_react.PureComponent), _class2.defaultProps = {
  Toast: _connectedToast2.default,
  isClosable: true,
  duration: _redux.DEFAULT_DURATION
}, _temp)) || _class) || _class);
process.env.NODE_ENV !== "production" ? ToastProvider.propTypes = {
  Toast: _propTypes2.default.func,
  duration: _propTypes2.default.number,
  isClosable: _propTypes2.default.bool
} : void 0;
exports.default = ToastProvider;